  <template>
  <b-modal style="padding:15px" size="lg" id="AddCompanyModal" ref="modal" title="Add Company" ok-title="Submit" cancel-title="Close" 
      @show= "resetModal()" @hidden= "resetModal()" @ok= "handleOk" :ok-disabled = "this.$refs.AddCompanyForm != undefined ? !this.$refs.AddCompanyForm.checkValidity() : true">
        <form ref="AddCompanyForm" @submit.stop.prevent= "handleSubmit">
          <div class="row">
            <div class="col-md-4">
              <!--NAME INPUT-->
              <b-form-group label="Company Name" label-for="companyname-input" autocomplete="off">
                <b-form-input id="companyname-input" v-model= "CompanyName"  required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
               <b-form-group  label="Address" label-for="address-input" autocomplete="off">
                <b-form-input id="address-input" v-model= "Address"  required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group  label="Phone" label-for="phone-input" autocomplete="off">
                <b-form-input id="phone-input" v-model= "PhoneNumber"  required></b-form-input>
              </b-form-group>
            </div>
          </div>
                  
        </form>
      </b-modal>
      </template>

      <script>
import axios from 'axios';
// import config from '../config.js';

export default {
    name: 'AddCompany',
    data(){
        return{
          moduleName:'Companies',
          Company:null,
          CompanyName:'',
          Address:'',
          PhoneNumber:'',     
		}
  },

methods:{

    addCompany(){ 
     axios.post('/company/Add', 
      {"CompanyName":this.CompanyName,"PhoneNumber":this.PhoneNumber, "Address":this.Address})
      .then(res=>{
            if(res.data.status == 1)
            {
                this.$bvModal.msgBoxOk('Company added successfully!', {
                title: 'Confirmation',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'success',
                headerClass: 'p-10 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
                });
                this.$bvModal.hide('AddCompanyModal')
                this.$router.go();
            }
            else if(res.data.status== -1)
            {  this.$bvModal.msgBoxOk(res.data.msg, {
                title: 'Error!',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                headerClass: 'p-10 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
                });
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },
   checkFormValidity() {
        const valid = this.$refs.AddCompanyForm.checkValidity()
        // this.usernameState = valid
        return valid
      },
      resetModal() {
        this.CompanyName='';
        this.Address = '';
        this.PhoneNumber = '';
       
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        } 
        this.addCompany()
        
        this.$nextTick(() => {
          //this.$router.go('/phones')
      
        })
      },
 
  
  },
	

}
</script>
